import { Progress } from 'antd';
import React from 'react';

import { FONT_SIZE, SPACING } from '../theme/tokens';
import { formatRemainingTime } from './format-remaining-time';

export interface IAutomatProgress {
  current: number;
  total: number;
  startedAt: number;
}

export function AutomatProgressBar({
  isRunning,
  progress,
}: {
  isRunning: boolean;
  progress: IAutomatProgress | null;
}): React.ReactElement | null {
  if (!isRunning || !progress) {
    return null;
  }

  return (
    <div style={{ marginTop: SPACING.sm }}>
      <Progress
        percent={Math.round((progress.current / progress.total) * 100)}
        size={{ height: 16 }}
      />
      <span style={{ fontSize: FONT_SIZE.xxl, fontWeight: 'bold' }}>
        {progress.current} / {progress.total}
        {progress.current > 0 &&
          ` · ${formatRemainingTime(Date.now() - progress.startedAt, progress.current, progress.total)} remaining`}
      </span>
    </div>
  );
}
